export const iconFontAwesomeMathematicsLessThan = (
	<i className="fa-solid fa-less-than"></i>
);
